import { Pipe, PipeTransform } from "@angular/core";
import { AddressArt } from "../_interfaces/address";
import { CrmService } from "../_provider/crm.service";


@Pipe({
    name: "AddressArtTagText",
    standalone: false
})
export class AddressArtTagText implements PipeTransform{

    constructor(
        private crmSrv: CrmService
    ){}

    transform(value: number, ...args: any[]) {
        return this.crmSrv.addressArts.find(aa => aa.id == value)?.description ?? "Keine Addressart"
    }

}

@Pipe({
    name: "AddressArtTagColor",
    standalone: false
})
export class AddressArtTagColorPipe implements PipeTransform{

    constructor(
        private crmSrv: CrmService
    ){}

    transform(value: number, ...args: any[]) {

        const art: AddressArt = this.crmSrv.addressArts.find(art => art?.id == value)
        switch (art?.id) {
            case 0: return `rgba(var(--textRGB), ${args[0] ?? 1})`
            case 1: return `rgba(var(--yellowRGB), ${args[0] ?? 1})`
            case 2: return `rgba(var(--greenRGB), ${args[0] ?? 1})`
            default: return `rgba(var(--blueRGB), ${args[0] ?? 1})`
        }
    }

}